import NewHeader from "../../components/NewHeader";
import NewFooter from "../../components/NewFooter";

export default function TestHomeLayout({ children }) {
  return (
    <div className="select-none">
      <NewHeader />
      <main className="pt-[68px] min-[1073px]:pt-[76px]">{children}</main>
      <NewFooter />
    </div>
  );
}
